import React from "react";
import * as ROUTES from "../../constants/routes";
import {
  GROUPS_ADD,
  GROUPS_DELETE,
  GROUPS_UPDATE,
  GROUPS_SELECT,
} from "../../constants/roles";
import BreadcrumbLink from "./BreadcrumbLink";

const GROUP_PERMISSIONS = [
  GROUPS_ADD,
  GROUPS_DELETE,
  GROUPS_UPDATE,
  GROUPS_SELECT,
];

/**
 * GroupLink
 *
 * Renders a link to a specific program's groups page if the user has
 * group-related permissions; otherwise renders plain text.
 *
 * Props:
 *  - programId {string} The program ID used to build the route
 *  - label     {string} The program name to display
 */
const GroupLink = ({ programId, label }) => {
  const to = `${ROUTES.PROGRAMS}/${programId}${ROUTES.GROUPS}`;

  return (
    <BreadcrumbLink
      to={to}
      label={label}
      permissions={GROUP_PERMISSIONS}
    />
  );
};

export default GroupLink;